module.exports = __webpack_public_path__ + "img/rob-smc.ee323577.jpg";